import keyMirror from 'keymirror'

export default keyMirror({
  RENDER_SEGMENTS_QR: null,
  RENDER_TEAMS: null,
  ADD_SEGMENTS_QR: null,
  RENDER_REPORT: null,
  NO_MORE_SEGMENTS: null,
})
